import React from "react";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { AppInsightsErrorBoundary } from "./AppInsightsErrorBoundary";

interface WrapperProps {
  children: React.ReactNode;
}

export const ErrorBoundaryWithAppInsights: React.FC<WrapperProps> = ({ children }) => {
  const appInsights = useAppInsightsContext();

  return (
    <AppInsightsErrorBoundary appInsights={appInsights}>
      {children}
    </AppInsightsErrorBoundary>
  );
};